import React, { Component } from 'react';
import '../../components/Form/form.scss';
import Button from "../../components/Form/Button/Button";
import TextInput from "../../components/Form/TextInput/TextInput";

interface Props {
    email: string;
    reach5: any;
    handleSubmit: () => void;
    handleResetEmail: () => void;
    backend: string;
}
interface State {
    password?: string;
    error: boolean;
    errorMessage: string;
}

class Login extends Component<Props, State> {

    state: State = { password: '', error: false, errorMessage: ''};

    componentDidMount() {
    }

    handleChange(password: string) {
        this.setState({ password: password.trim() })
    }
    handleSubmit() {
        console.log('back redirect url = ' + this.props.backend +'/api/redirect')
        this.props.reach5
            .loginWithPassword({
                email: this.props.email,
                password: this.state.password,
                auth: {
                     redirectUri: this.props.backend +'/api/redirect',
                 },
            })
            .then(() => {
                this.props.handleSubmit();
            })
            .catch((error: any) => {
                console.log(error);
                this.setState({ error: true, errorMessage: error.errorUsrMsg });
            });
    }

    render() {
        return (
            <form onSubmit={() => this.handleSubmit()} role='login'>
                <h3>Connexion</h3>
                <p className='user-mail'>
                    {this.props.email}
                    <button onClick={() => this.props.handleResetEmail()}>(modifier)</button>
                </p>
                <TextInput
                    onChange={(email: string) => this.handleChange(email)}
                    type="password"
                    label="Mot de passe"
                    value={this.state.password || ''}
                    error={this.state.error}
                    autofocus={true}
                    mandatory={true}
                    id='password'
                />
                {this.state.errorMessage && (
                    <p className='red'>{this.state.errorMessage}</p>
                )}
                <Button
                    label='Se connecter'
                    onClick={() => this.handleSubmit()}
                />
            </form>
        );
    }
}
export default Login;